import axios from 'axios';

import { getEnv } from '@/lib/env';

const publicClient = axios.create({
  baseURL: getEnv('VITE_API_URL'),
});

export interface PublicDocumentMeta {
  displayName: string;
  mimeType: string | null;
  sizeBytes: number | null;
  kind: 'pdf' | 'markdown' | 'text' | 'image' | 'office' | 'unsupported';
}

export const publicDocumentApi = {
  getMeta: async (token: string): Promise<PublicDocumentMeta> => {
    const response = await publicClient.get<PublicDocumentMeta>(`/public/documents/${token}`);
    return response.data;
  },

  getContentUrl: (token: string, download = false): string => {
    const base = getEnv('VITE_API_URL');
    return `${base}/public/documents/${token}/content${download ? '?download=1' : ''}`;
  },
};
